import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON } from 'gcs-common/constants/IconConstants';
import type { ReactNode } from 'react';
import styles from './styles.module.scss';

interface EditingCellProps {
  isEditing: boolean;
  setIsEditing: (arg0: boolean) => void;
  onSave: VoidFunction;
  onCancel: VoidFunction;
  children: ReactNode;
  disabled: boolean;
}

const EditingCell = (props: EditingCellProps) => {
  const { isEditing, setIsEditing, onSave, onCancel, children, disabled } = props;
  return (
    <div className={styles.wrapper}>
      {children}
      {isEditing ? (
        <>
          <button
            className={styles.saveButton}
            type="button"
            onClick={async () => {
              await onSave();
              setIsEditing(!isEditing);
            }}
            disabled={disabled}
          >
            <IconComponent Icon={ICON.SAVE} />
          </button>
          <button
            className={styles.saveButton}
            type="button"
            onClick={async () => {
              await onCancel();
              setIsEditing(!isEditing);
            }}
            disabled={disabled}
          >
            <IconComponent Icon={ICON.CLOSE} />
          </button>
        </>
      ) : (
        <button
          className={styles.saveButton}
          type="button"
          onClick={() => {
            setIsEditing(!isEditing);
          }}
        >
          <IconComponent Icon={ICON.EDIT} />
        </button>
      )}
    </div>
  );
};

export default EditingCell;
